import { getToken, onMessage } from "firebase/messaging";
import {
  isMessgingSupported,
  messaging,
  messagingKey,
} from "../../config/firebase.config";
import { apiClient } from "../../config/api.config";
import AuthController from "../auth";
import ToastController from "../ToastController";
import { setNotifications } from "../../store/slices/NotificationSlice";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "../../store";

class NotificationController {
  static getFcmToken(_callback = () => false) {
    return new Promise((resolve, reject) => {
      if (!isMessgingSupported) {
        resolve(false);
        return;
      }
      Notification.requestPermission()
        .then((res) => {
          if (res === "granted" && messaging) {
            getToken(messaging, { vapidKey: messagingKey })
              .then((token) => {
                console.log(token, "@token  .!");
                _callback(token);
                resolve(token);
              })
              .catch((err) => {
                _callback(false);
                console.log(err, "@token  error.!");
                reject(err);
              });
          }
        })
        .catch((err) => {
          console.log("@notification err...", err);
          reject("Notification permission blocked!");
        });
    });
  }

  static saveFcmToken(token) {
    console.log("@save token ....", token);
    return new Promise((resolve, reject) => {
      apiClient
        .patch("/admin/auth/save-notification-token", {
          token,
        })
        .then((res) => {
          console.log("@save token res...", res?.data);
          if (res?.data?.success) {
            resolve(res?.data?.data);
            let session = AuthController.getPersistedCredentials();
            session = {
              ...session,
              fcm_token: token,
            };
            AuthController.persistCredentials(session);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@save token err...", err?.response?.data);
          reject(err?.response?.data);
        });
    });
  }

  static removeFcmToken(token) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete("/admin/auth/delete-notification-token", {
          token,
        })
        .then((res) => {
          console.log("@delete fcm token...", res?.data);
          if (res?.data?.success) {
            resolve(res?.data?.data);
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@delete token err...", err?.response?.data);
          reject(err?.response?.data);
        });
    });
  }
  static onNotification() {
    if (!isMessgingSupported) {
      return;
    }
    onMessage(messaging, (payload) => {
      console.log(payload, "@notification.!");
      NotificationController.getAll();
      ToastController.success(payload?.notification?.title);
      new Notification(
        payload?.notification?.title,
        payload?.notification?.body
      );
    });
  }
  static getAll() {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`/admin/auth/notifications`)
        .then((res) => {
          console.log("@noti res......", res?.data);
          if (res?.data?.success) {
            resolve(res?.data?.data);
            store.dispatch(setNotifications(res?.data?.data));
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@noti err......", err);
          reject("Network Error!");
        });
    });
  }
  static markAsRead(notificationId) {
    console.log("@mark id....", notificationId);
    const formData = notificationId ? { notificationId } : { updateAll: true };
    return new Promise((resolve, reject) => {
      apiClient
        .put(`/admin/auth/notifications`, formData)
        .then((res) => {
          console.log("@mark res....", res?.data);
          if (res?.data?.success) {
            resolve(res?.data?.data);
            ToastController.success("Marked as read!");
            store.dispatch(setNotifications(res?.data?.data));
          } else {
            reject(res?.data);
          }
        })
        .catch((err) => {
          console.log("@mark err....", err);
          reject("Network error!");
        });
    });
  }
}

export default NotificationController;

export const useNotifications = () => {
  const [isLoading, setIsLoading] = useState(true);
  const notifications = useSelector(
    (state) => state.Notifications.notifications
  );

  function getAllNotifications() {
    setIsLoading(true);
    NotificationController.getAll()
      .then(() => {
        // store.dispatch(setNotifications(res));
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    getAllNotifications();
  }, []);

  return {
    notifications: notifications,
    loading: isLoading,
  };
};
